<template>
  <div class="subscriptions">
    <ul class="subscriptions__list" data-test="tab-subscriptions">
      <li v-for="(item, index) in subscriptions" :index="index" :key="index" class="entry" :class="{'entry--dark-mode': darkMode}">
        <a :href="item.url" target="_blank">{{item.title}}</a>
      </li>
    </ul>

  </div>
</template>

<script>
import { mapState } from 'redux-vuex';
import select from '@/store/selectors';

export default {
  data: mapState({
    subscriptions: select.subscriptions.list,
    darkMode: select.customOptions.darkMode,
  }),
};

</script>

<style lang="scss" scoped>
  @import '~@/assets/scss/tokens/tab.scss';
  @import '~@/assets/scss/media.scss';

  .subscriptions{
    @extend %tab-wrapper;
  }

  .entry {
    color: #000000;
    height: 30px;
    font-size: 12px;
    line-height: 30px;
    overflow: hidden;

    @include only-desktop() {
      font-size: 14px;
    }

    &:hover {
      font-weight: bold;
    }

    &--dark-mode {
      color: #FFFFFF;
    }
  }
</style>
